enum QesIconsFontAwesome {
  AngleDoubleRight = "Angle Double Right",
  AngleDoubleUp = "Angle Double Up",
  Archive = "Archive",
  ArrowDown = "Arrow Down",
  ArrowLeft = "Arrow Left",
  ArrowRight = "Arrow Right",
  ArrowUp = "Arrow Up",
  Arrows = "Arrows",
  ArrowsHorizontal = "Arrows Horizontal",
  ArrowsVertical = "Arrows Vertical",
  Ban = "Ban",
  Bank = "Bank",
  BarChart = "Bar Chart",
  Binoculars = "Binoculars",
  Book = "Book",
  Briefcase = "Briefcase",
  Building = "Building",
  Bullseye = "Bullseye",
  Calendar = "Calendar",
  CaretDown = "Caret Down",
  CaretRight = "Caret Right",
  CaretUp = "Caret Up",
  Chain = "Chain",
  Check = "Check",
  CheckCircle = "Check Circle",
  CheckSquare = "Check Square",
  CheckSquareOutline = "Check Square Outline",
  ChevronDown = "Chevron Down",
  ChevronRight = "Chevron Right",
  Circle = "Circle",
  CircleOutline = "Circle Outline",
  CircleOutlineNotched = "Circle Outline Notched",
  CircleThin = "Circle Thin",
  ClockOutline = "Clock Outline",
  Clone = "Clone",
  Close = "Close",
  CloudDownload = "Cloud Download",
  Cog = "Cog",
  Cogs = "Cogs",
  Copy = "Copy",
  Crosshairs = "Crosshairs",
  Database = "Database",
  Desktop = "Desktop",
  DotCircleOutline = "Dot Circle Outline",
  Download = "Download",
  DragAndDropTexture = "Drag And Drop Texture",
  Edit = "Edit",
  EllipsisVertical = "Ellipsis Vertical",
  Envelope = "Envelope",
  Eraser = "Eraser",
  Exchange = "Exchange",
  ExclamationCircle = "Exclamation Circle",
  ExclamationTriangle = "Exclamation Triangle",
  ExternalLink = "External Link",
  Eye = "Eye",
  Fax = "Fax",
  FilePdfOutline = "File PDF Outline",
  FilesOutline = "Files Outline",
  FileZipOutline = "File Zip Outline",
  Filter = "Filter",
  FloppyDiskOutline = "Floppy Disk Outline",
  Folder = "Folder",
  Globe = "Globe",
  History = "History",
  Home = "Home",
  IdBadge = "ID Badge",
  InfoCircle = "Info Circle",
  Laptop = "Laptop",
  Layers3v1 = "Layers (3) v1",
  LineChart = "Line Chart",
  List = "List",
  LocationArrow = "Location Arrow",
  Lock = "Lock",
  LongArrowDown = "Long Arrow Down",
  LongArrowUp = "Long Arrow Up",
  LowVision = "Low Vision",
  Map = "Map",
  MapMarker = "Map Marker",
  MapPin = "Map Pin",
  Minus = "Minus",
  MinusCircle = "Minus Circle",
  ObjectGroup = "Object Group",
  Pencil = "Pencil",
  PencilSquareOutline = "Pencil Square Outline",
  Pentagon = "Pentagon",
  Phone = "Phone",
  Play = "Play",
  Plug = "Plug",
  Plus = "Plus",
  PlusCircle = "Plus Circle",
  Question = "Question",
  QuestionCircle = "Question Circle",
  Refresh = "Refresh",
  Rocket = "Rocket",
  Search = "Search",
  Sellsy = "Sellsy",
  Server = "Server",
  Share = "Share",
  SignIn = "Sign In",
  SignOut = "Sign Out",
  Sliders = "Sliders",
  Sort = "Sort",
  Spinner = "Spinner",
  Square = "Square",
  SquareOutline = "Square Outline",
  Star = "Star",
  Stop = "Stop",
  StopCircle = "Stop Circle",
  StopCircleOutline = "Stop Circle Outline",
  Tag = "Tag",
  Tags = "Tags",
  Tasks = "Tasks",
  ThLarge = "Th Large",
  ThumbsOutlineUp = "Thumbs Outline Up",
  Times = "Times",
  TimesCircle = "Times Circle",
  TimesCircleOutline = "Times Circle Outline",
  TimesLight = "Times Light",
  ToggleOff = "Toggle Off",
  ToggleOn = "Toggle On",
  Trash = "Trash",
  TrashOutline = "Trash Outline",
  Umbrella = "Umbrella",
  University = "University",
  Unlock = "Unlock",
  Upload = "Upload",
  User = "User",
  UserMd = "User MD",
  UserPlus = "User Plus",
  Users = "Users",
  UserTimes = "User Times",
  Wrench = "Wrench",
}

enum QesIconsUntitled {
  AlertHexagon = "Alert Hexagon",
  AlertTriangle = "Alert Triangle",
  AlignLeftV1 = "Align Left v1",
  AlignRightV1 = "Align Right v1",
  Archive = "Archive (Untitled UI)",
  ArrowNarrowDown = "Arrow Narrow Down",
  ArrowNarrowUp = "Arrow Narrow Up",
  Briefcase = "Briefcase",
  BuildingV7 = "Building v7",
  CheckCircle = "Check Circle (Untitled UI)",
  ChevronDown = "Chevron Down (Untitled UI)",
  ChevronLeft = "Chevron Left",
  ChevronRight = "Chevron Right (Untitled UI)",
  ChevronUp = "Chevron Up",
  Circle = "Circle (Untitled UI)",
  CopyV7 = "Copy v7",
  Database = "Database",
  DotsVertical = "DotsVertical",
  Download = "Download",
  ExpandV1 = "Expand v1",
  Eye = "Eye (Untitled UI)",
  EyeOff = "Eye Off",
  FilterLines = "Filter Lines",
  FlagV1 = "Flag v1",
  Folder = "Folder (Untitled UI)",
  GlassesV2 = "Glasses v2",
  GridV1 = "Grid v1",
  HexagonOnEdge = "Hexagon (on Edge)",
  HexagonOnVertex = "Hexagon (on Vertex)",
  InfoCircle = "Info Circle (Untitled UI)",
  LayersThreeV1 = "Layers (3) v1",
  LayersThreeV2 = "Layers (3) v2",
  LayersTwoV1 = "Layers (2) v1",
  LayersTwoV2 = "Layers (2) v2",
  LifeBuoyV1 = "Life Buoy v1",
  List = "List (Untitled UI)",
  LoadingV1 = "Loading v1",
  MenuV1 = "Menu v1",
  PencilV1 = "Pencil v1",
  Pentagon = "Pentagon",
  PhoneV1 = "Phone v1 (Untitled UI)",
  Plus = "Plus (Untitled UI)",
  PresentationChartV1 = "Presentation Chart v1",
  Printer = "Printer",
  RefreshCcwV2 = "Refresh CCW v2",
  RocketV2 = "Rocket v2",
  Route = "Route",
  SaveV1 = "Save v1",
  ScissorsV2 = "Scissors v2",
  SearchSm = "Search Small",
  SettingsV2 = "Settings v2",
  ShareV4 = "Share v4",
  ShareV6 = "Share v6",
  SlashOctagon = "Slash Octagon",
  SlidersV4 = "Sliders v4",
  Square = "Square",
  SwitchHorizontalV1 = "Switch Horizontal v1",
  SwitchVerticalV1 = "Switch Vertical v1",
  TargetV4 = "Target v4",
  TerminalBrowser = "Terminal Browser",
  ToolV2 = "Tool v2",
  TrashV1 = "Trash v1",
  UploadV1 = "Upload v1",
  UsersV1 = "Users v1",
  UserV1 = "User v1",
  X = "X",
  XClose = "X Close",
  Zap = "Zap",

  ArrowNarrowRight = "Arrow Narrow Right",
  Bank = "Bank",
  Check = "Check (Untitled UI)",
  CheckSquareBroken = "Check Square Broken",
  ChevronRightDouble = "Chevron Right Double",
  ChevronUpDouble = "Chevron Up Double",
  Clock = "Clock",
  ClockRewind = "Clock Rewind",
  DownloadCloudV2 = "Download Cloud v2",
  EditV5 = "Edit v5",
  Eraser = "Eraser",
  Help = "Help",
  HelpCircle = "Help Circle",
  HomeV3 = "Home v3",
  LaptopV2 = "Laptop v2",
  LineChartUpV2 = "Line Chart Up v2",
  LinkV4 = "Link v4",
  MailV1 = "Mail v1",
  MapV1 = "Map v1",
  MarkerPinV6 = "Marker Pin v6",
  Minus = "Minus (Untitled UI)",
  MinusCircle = "Minus Circle (Untitled UI)",
  MonitorV5 = "Monitor v5",
  Play = "Play (Untitled UI)",
  PlusCircle = "Plus Circle (Untitled UI)",
  LogInV1 = "Sign In v1",
  LogOutV1 = "Sign Out v1",
  SlashCircle = "Slash Circle",
  StarV1 = "Star v1",
  Stop = "Stop (Untitled UI)",
  StopCircle = "Stop Circle (Untitled UI)",
  TagV1 = "Tag v1",
  TagV3 = "Tag v3",
  TargetV2 = "Target v2",
  ThumbsUp = "Thumbs Up",
  ToggleV1Left = "Toggle v1 Left",
  ToggleV1Right = "Toggle v1 Right",
  ToolV1 = "Tool v1",
  UmbrellaV2 = "Umbrella v2",
  xCircle = "X Circle",
}

export const QesIcons = {
  FontAwesome: QesIconsFontAwesome,
  Untitled: QesIconsUntitled,
}

export type QesIcons = typeof QesIcons;